import { paths } from '@/routes/helpers/paths';
import { Link } from '@/ui/link/link';
import { EllipsisTextTooltip } from '@/ui/table/infinite-table/ellipsis-text-tooltip';
import { styled } from 'goober';
import { useTranslation } from 'react-i18next';

type ProjectCreatedForCellProps = {
  createdFor: {
    id?: string;
    name?: string;
  } | null;
  disableLink?: boolean;
};

export const ProjectCreatedForCell = ({
  createdFor,
  disableLink,
}: ProjectCreatedForCellProps) => {
  const { t } = useTranslation('projects');

  return (
    <CreatedForCell>
      {createdFor?.id && (
        <StyledEllipsisTextTooltip
          text={t('companies:companies.forTeam', {
            teamName: createdFor.name,
          })}
          Component={
            disableLink ? (
              <Text>{createdFor.name}</Text>
            ) : (
              <Link to={paths.team({ teamId: createdFor.id })} />
            )
          }
        />
      )}
    </CreatedForCell>
  );
};

const CreatedForCell = styled('div')`
  max-width: 130px;
  a {
    ${({ theme }) => theme.mixins.ellipsis}
    ${({ theme }) => theme.typography.globalSearch.suggestionsTable.smallText};
    font-size: 12px;
    display: inline-block;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Text = styled('p')`
  ${({ theme }) => theme.typography.globalSearch.suggestionsTable.smallText};
`;

const StyledEllipsisTextTooltip = styled(EllipsisTextTooltip)`
  ${({ theme }) => theme.typography.globalSearch.suggestionsTable.smallText};
  display: flex;
  align-items: center;
`;
